import Swal from "sweetalert2";
import { resources_EN } from "../GenericServices/componentUtils";
import { PostService } from "../GenericServices/genericService";
import { useState } from "react";

const AddCategoryModal = ({
  showAddCategoryModal,
  getCategoryAPI,
  setShowAddCategoryModal,
}) => {
  const [categoryName, setCategoryName] = useState("");

  const handleAddCategory = () => {};

  const addCategoryAPI = () => {
    const url = "myNewAPI/add_category.php";
    const data = { cat_title: categoryName };
    PostService(url, data, modal);
  };

  /* Error or Success Modal */
  const modal = (icon, title, message, response = "") => {
    Swal.fire({
      title: title,
      icon: icon,
      text: message,
    }).then((resp) => {
      if (resp.isConfirmed && icon === resources_EN.success) {
        setShowAddCategoryModal(false);
        setCategoryName("");
        getCategoryAPI();
      }
    });
  };

  return showAddCategoryModal ? (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-[100] flex items-center justify-center p-4">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <h2 className="text-xl font-bold mb-4">Add Category</h2>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleAddCategory();
          }}
        >
          <input
            type="text"
            placeholder="Category Name"
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
            className="w-full mb-4 p-2 border"
            required
          />
          <div className="flex justify-end">
            <button
              type="button"
              onClick={() => setShowAddCategoryModal(false)}
              className="mr-4 px-4 py-2 text-gray-600"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={addCategoryAPI}
              className="px-4 py-2 bg-blue-600 text-white"
            >
              Add
            </button>
          </div>
        </form>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default AddCategoryModal;
